<template>
  <div></div>
</template>

<script lang="ts">
import { useSessionStore } from '@/stores/SessionStore.ts';

export default {
  name: 'Intercom',
  props: {
    admin: { type: Boolean },
  },
  mounted() {
    if (this.intercomEnabled) {
      const user = useSessionStore().user;

      this.$intercom.boot({
        user_id: user.id.toString(),
        name: user.firstName + ' ' + user.lastName,
        email: user.email,
      });
      this.$intercom.hide();
    }
  },
  unmounted() {
    if (import.meta.env.VITE_INTERCOM_APP_ID) {
      this.$intercom.shutdown();
    }
  },
  computed: {
    intercomEnabled() {
      if (!import.meta.env.VITE_INTERCOM_APP_ID) return false;
      if (useSessionStore().user && !this.admin) return true;
      if (
        useSessionStore().user &&
        this.admin &&
        import.meta.env.VITE_INTERCOM_ENABLED_FOR_ADMIN
      )
        return true;
      return false;
    },
  },
};
</script>
